import { render, staticRenderFns } from "./BrowserCheck.vue?vue&type=template&id=50520c18&"
import script from "./BrowserCheck.vue?vue&type=script&lang=js&"
export * from "./BrowserCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports